var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendButtonYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_2139_31167)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5194 15.9716C22.3226 16.1706 22.0035 16.1706 21.8067 15.9716L16.1404 10.2403L16.1404 22.9903C16.1404 23.2718 15.9148 23.5 15.6365 23.5C15.3581 23.5 15.1325 23.2718 15.1325 22.9903L15.1325 10.2403L9.46619 15.9716C9.2694 16.1706 8.95032 16.1706 8.75353 15.9716C8.55673 15.7725 8.55673 15.4498 8.75353 15.2507L15.2801 8.64929C15.4769 8.45024 15.796 8.45024 15.9928 8.64929L22.5194 15.2507C22.7162 15.4498 22.7162 15.7725 22.5194 15.9716Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2139_31167",
    x1: 16,
    y1: 32,
    x2: 16,
    y2: 0.0000114441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF881E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB341"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButtonYes);
export default __webpack_public_path__ + "static/media/send_button_yes.658bf09837e37f36ed31fc149b435cb9.svg";
export { ForwardRef as ReactComponent };